<template>
  <div id="baseInfo">
    <Title title="基础信息完善" />
    <div class="form">
      <ul>
        <li>
          <input type="text" placeholder="请输入您的姓名" v-model="name" />
          <i class="close" v-if="name !== ''" @click="name = ''">×</i>
        </li>
        <li>
          <input type="text" placeholder="请输入您的车牌号" v-model="code" />
          <i class="close" v-if="code !== ''" @click="code = ''">×</i>
        </li>
      </ul>
      <div class="btn">
        <mt-button size="large" type="primary" @click="addBaseInfo"
          >下一步</mt-button
        >
        <p class="green" @click="returnTicket">跳过</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "@/components/Title";
export default {
  components: {
    Title,
  },
  data() {
    return {
      name: "",
      code: "",
      flag: "",
    };
  },
  mounted() {
    this.flag = this.$route.query.flag;
  },
  methods: {
    //基础信息完善
    addBaseInfo() {
      if (this.name == "") {
        this.$toast({
          message: "请输入您的姓名",
          duration: 1000,
        });
        return;
      }
      if (this.code == "") {
        this.$toast({
          message: "请输入您的车牌号",
          duration: 1000,
        });
        return;
      }
      this.post(this.apis.saveBaseInfo, {
        cardNum: this.code,
        driverName: this.name,
        memberId: this.userInfo.memberId,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.returnTicket();
          } else {
            this.$toast({
              message: response.data.retMsg,
              duration: 1800,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //返回卡券
    returnTicket() {
      this.flag ? this.changeRouter("/ticket") : this.changeRouter("/exchange");
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  beforeDestroy() {
    this.flag = "";
  },
};
</script>

<style lang="less" scoped>
#baseInfo {
  background-color: #fff;
  padding: 0 70px;
  .form {
    li {
      margin-top: 10px;
      height: 104px;
      border-bottom: 1px solid #c5c5c5;
      display: flex;
      justify-content: space-between;
      align-items: center;
      input {
        border: none;
        height: 90px;
        width: 70%;
        outline: none;
        font-size: 30px;
      }
      .code {
        line-height: 90px;
        width: 28%;
        text-align: center;
        font-size: 30px;
        color: #1fbe6e;
        word-break: keep-all;
        &.sending {
          color: #c5c5c5;
        }
      }
      .close {
        font-style: normal;
        width: 32px;
        height: 32px;
        background-color: #8e8e93;
        font-size: 32px;
        color: #fff;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
      }
    }
    .agree {
      margin-top: 55px;
      display: flex;
      font-size: 24px;
      color: #ababab;
      line-height: 37px;
      span {
        color: #1fbe6e;
      }
      .check {
        width: 46px;
        height: 46px;
        position: relative;
        top: -5px;
        left: -10px;
      }
    }
    .mint-checkbox-label {
      font-size: 30px;
    }
    .btn {
      margin-top: 62px;
      .green {
        padding-top: 30px;
        text-align: center;
        font-size: 26px;
      }
    }
  }
}
</style>
